(function () {
  'use strict';

  if (window.__apexCardSwatchesInit) return;
  window.__apexCardSwatchesInit = true;

  function getMainImage(swatchWrap) {
    var card = swatchWrap.closest('.card-wrapper');
    if (!card) return null;
    return card.querySelector('.card__media img');
  }

  function swapImage(img, newSrc) {
    if (!img || !newSrc) return;
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.src;
    }
    if (!img.dataset.originalSrcset && img.srcset) {
      img.dataset.originalSrcset = img.srcset;
    }
    img.removeAttribute('srcset');
    img.src = newSrc;
  }

  document.addEventListener('click', function (e) {
    var wrap = e.target.closest('.card-swatch__wrap');
    if (!wrap) return;
    e.preventDefault();
    e.stopPropagation();
    var newSrc = wrap.getAttribute('data-swatch-image');
    if (!newSrc) return;
    var img = getMainImage(wrap);
    swapImage(img, newSrc);
  });
})();